import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M458.5 239.3c-.23 48.81 0 195.26 0 195.26 0 36.05-30.22 65.43-67.31 65.43H128.62c-24.97.31-43.46-15.02-60.35-29.49-15.86-13.58-27.14-32.96-26.76-55.74V219.5c-.43-39.24 37.45-71.07 77.1-64.6-5.63-9.38-8.75-20.01-8.75-31.05h.21c-4.97-38.32 66.34-82.88 87.31-107.32 24.64-23.3 63.36-21.07 87.52 1.05l68.35 63.56c1.22 1.42 13.44 14.01 15 16.05 16.92 14.59 25.67 37.63 20.42 59.39 14.74 3.43 27.8 12.19 37.51 23.55 1.45 1.3 6.56 6.77 7.92 8.33 14.21 13.1 24.48 30.15 24.38 50.85Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fafafb",
			d: "m225.22 46.65-68.16 63.33c-8.22 7.61-8.22 20.05 0 27.65 8.22 7.61 21.49 7.61 29.61 0l32.38-30.12v200.47c0 10.79 9.35 19.53 20.97 19.53s20.97-8.74 20.97-19.53V107.5l32.38 30.12c8.23 7.61 21.48 7.61 29.61 0 8.22-7.61 8.22-19.94 0-27.55l-68.26-63.43c-8.22-7.61-21.48-7.61-29.61 0h.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M397.44 219.5v195.26c0 13.34-11.67 24.38-26.05 24.38H108.82c-2.08 0-3.75-.63-5.63-1.04-11.67-2.5-20.63-11.88-20.63-23.34V219.5h.21c0-13.54 11.67-24.38 26.26-24.38s26.05 10.84 26.05 24.38v170.67h210.06V219.5c0-13.54 11.67-24.38 26.26-24.38s26.05 10.84 26.05 24.38Z"
		})
	]
});
export default SvgShare;
